import script from "./caseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./caseDetails.vue?vue&type=script&setup=true&lang=js"

import "./caseDetails.vue?vue&type=style&index=0&id=0d601452&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d601452"]])

export default __exports__